import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '~/@api/client/authStore'
import { _trackHsqIdentity } from '~/@lib_integrations/analytics/hubspot'
import Analytics from '~/@lib_integrations/analytics/analytics'
import { setLoggedUserEmailToACVisitor } from '~/@lib_integrations/analytics/activeCampaign'
import {
  useRegister,
  type RegisterRequest,
} from '~/@mid_registration/register-form/useRegister'
import RegistrationComponent from '~/@mid_registration/RegistrationComponent'
import { useAffilToken } from '~/@pages_auth/register/affiliate/useAffilToken'

function AmbassadorRegistrationPage() {
  const { setAuthToken } = useAuthStore()
  const navigate = useNavigate()
  const { tokenAffilRecommender, removeToken: removeAffilToken } =
    useAffilToken()
  const { error, registerUserMutation, isRegisterRequesting } = useRegister()

  function handleRegisterUser(data: RegisterRequest) {
    registerUserMutation(
      {
        ...data,
        tokenAffilRecommender,
        ambassador: true,
      },
      {
        onSuccess: (resp) => {
          setAuthToken(resp.auth)
          removeAffilToken()

          Analytics.track('user-registered')
          setLoggedUserEmailToACVisitor(data.email)
          _trackHsqIdentity(data.email)

          navigate('/get-started')
        },
      }
    )
  }

  return (
    <RegistrationComponent
      title="Vytvoriť účet ako ambasádor"
      description="Po registrácii bude automaticky zaslaná žiadosť pre vstup do ambasádorského rozhrania. Po schválení vás kontaktuje náš zástupca."
      isRegistering={isRegisterRequesting}
      handleRegisterUser={handleRegisterUser}
      error={error}
    />
  )
}

export default AmbassadorRegistrationPage
